<template>
  <div class="wrapper">
    <div class="container">
      <div class="title">
        <div class="title_info">
            <div class="info">
                <p class="tip1" v-if="userInfo.userInfo">欢迎您：{{(userInfo.userInfo || {}).name}}</p>
                <div class="name">
                    <p v-if="userInfo.depts">所属机构：{{(userInfo.depts[0] || {}).orgName}}</p>
                    <p class="name_line"></p>
                    <p  v-if="userInfo.depts">{{(userInfo.depts[0] || {}).name}}</p>
                </div>
            </div>
            <div class="img">
                <img src="../../../../assets/complaint/ic_work_bg.png" alt="">
            </div>
        </div>
      </div>
      <div class="check_list">
        <div class="item" v-if="menuList.complainDealCount&&menuList.complainDealCount.length>0">
          <p class="t_text">本级处理工作台</p>
          <div class="box">
            <div
              class="left line_bottom " v-for="(item, index) in menuList.complainDealCount" :key='index' @click="Workbench(item,'1')" :class="{'line_right':index%2!=1}">
              <p class="status">{{item.name}}(件)</p>
              <div class="num">
                <span></span>
                <span>{{item.total}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="item" v-if="menuList.complainLitigationCount&&menuList.complainLitigationCount.length>0">
          <p class="t_text">转诉案工作台</p>
          <div class="box">
            <div
              class="left line_bottom" v-for="(item, index) in menuList.complainLitigationCount" :key='index' @click="Workbench(item,'2')" :class="{'line_right':index%2!=1}">
              <p class="status">{{item.name}}(件)</p>
              <div class="num">
                <span></span>
                <span>{{item.total}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="item" v-if="menuList.complainSearchCount&&menuList.complainSearchCount.length>0">
          <p class="t_text">权限查询工作台 ({{userInfo.depts[0].areaName}})</p>
          <div class="box">
            <div class="father">
                <div
                  class="left line_bottom" v-for="(item, index) in menuList.complainSearchCount" :key='index' @click="Workbench(item,'3')" :class="{'line_right':index%2!=1}">
                  <p class="status">{{item.name}}(件)</p>
                  <div class="num">
                    <span></span>
                    <span>{{item.total}}</span>
                  </div>
                </div>
            </div>
            <div class="complaintStatistics" @click="statistics()" v-if="this.userInfo.userInfo.complainRole!='enterprise_staff'">
                数据可视化 >
            </div>
          </div>
        </div>
        <div class="item">
          <p class="t_text">近30天投诉数据</p>
          <div class="box linecharts">
            <lineCharts v-if="trendList.length !== 0" :data="trendList" :color="color"  :showYear="true"/>
          </div>
        </div>
        <div class="item checkItem" v-if="syntheticalWarning&&syntheticalWarning.length>0">
          <p class="t_text">综合预警</p>
          <div class="box comprehensiveWarning">
            <van-swipe :autoplay="3000" indicator-color="#bbbbbb">
                <van-swipe-item v-for="(item, index) in syntheticalWarning" :key='index' @click="goSyntheticalWarning(item.typeCode)">
                    <div class="area"><span>{{item.name}}</span></div>
                    <div class="totalComplaints"><span>{{item.warning}}，{{item.description}}</span></div>
                    <div class="deadline"><span>{{item.time}}</span></div>
                </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <div class="item" v-if="timeLimit">
          <p class="t_text">时限预警</p>
          <div class="box timeLimit">
              <div class="blueWarning" v-for="(item,index) in timeLimit" :key="index" @click="Warn('timeLimit',item)">
                <!-- <div class="blueWarning" v-for="(item,index) in timeLimit" :key="index" @click="goSyntheticalWarning(item)" > -->
                  <div class="warningTitle">{{item.name}}(件)</div>
                  <div class="warningNum blue">{{item.value}}</div>
              </div>
          </div>
        </div>
        <div class="item" v-if="emergency">
          <p class="t_text">紧急程度</p>
          <div class="box timeLimit">
              <div class="blueWarning" v-for="(item,index) in emergency" :key="index" @click="Warn('emergency',item)">
                  <div class="warningTitle">{{item.name}}</div>
                  <div class="warningNum blue">{{item.value}}</div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis'
    import lineCharts from '../../../../components/LineCharts';
    import util from '../../../../utils/common'
    // import api from '../../../../service/modules/complaint'
    export default {
        components: {
            lineCharts
        },
        data () {
            return {
                menuList:'',//首页菜单
                timeLimit:'',
                emergency:'',
                syntheticalWarning:'',
                userInfo:'',
                color: 'green',
                trendList:[],
                
            }
        },
        created () {
            this.getUser();
            this.getMenuList();
            this.getSyntheticalWarning();
            this.getEmergency();
            this.getTimeLimit();
            this.getTrend();
            this.$store.dispatch('complaint/channerList',{});
            util.setJsonLocal('waitResponse','');
        },
        mounted () {
            this.getNoticeNum()
        },
        methods: {
            getAllCity () {
                // 获取所有的市
                const params = {
                    data: {
                        cityCode: this.userInfo.depts[0].txId
                    }
                };
                this.$store.dispatch('complaint/region', params).then(data => {
                    // 当前用户所属城市下级城市列表
                });
            },
            getUser(){//获取用户信息
              api.common.user({}).then(res=>{
                if(res.ret==0){
                  this.userInfo=res.data;
                  const deptInfo = (res.data.depts || [])[0] || {};
                  util.setJsonLocal('userInfoComplaint',res.data);
                  this.$store.commit('complaint/setUserInfo', res.data);
                  this.$store.commit('complaint/setDeptInfo', deptInfo);
                  this.$store.commit('complaint/setUserInfo', res.data);
                  this.getAllCity();
                  // if (res.data.userInfo.orgType === 'tszhzx' || res.data.userInfo.orgType.indexOf('wbtj') === 0 || res.data.userInfo.orgType.indexOf('company') === 0) {
                  //     this.mechanism = item.orgName
                  // }
                }
              })
            },
            getMenuList(){//首页菜单
              const params={'isFromObject': 1, 'isFromTIO': 1}
              api.worker.menuList(params).then(res=>{
                if(res.ret==0){
                  this.menuList=res.data;
                }
              })
            },
            getSyntheticalWarning(){//综合预警
              api.common.queryAllsyntheticalWarning({}).then(res=>{
                console.log(res);
                if(res.ret==0){
                  if(res.data.syntheticalWarning.list&&res.data.syntheticalWarning.list.length>0)
                  this.syntheticalWarning = res.data.syntheticalWarning.list
                }
              })
            },
            getEmergency(){//紧急程度
                api.common.queryAllemergency({}).then(res=>{
                  if(res.ret==0){
                    if(res.data.emergency&&res.data.emergency.length>0){
                      this.emergency=res.data.emergency;
                    }
                  }
                })
            },
            getTimeLimit(){//限时预警
              api.common.queryAlltimeLimit({}).then(res=>{
                console.log(res);
                if(res.ret==0){
                  if(res.data.timeLimit&&res.data.timeLimit.length>0){
                    this.timeLimit=res.data.timeLimit;
                  }
                }
              })
            },
            getTrend(){//近30天投诉趋势
               api.common.trend({}).then(res=>{
                  console.log(res);
                  if(res.ret==0){
                    if(res.data.trend&&res.data.trend.length>0){
                      let arr = []
                      res.data.trend.map(item=>{
                        arr.push({ xAxis: item.day.substr(5), num: item.num + '' })
                      })
                      this.trendList= arr.reverse();
                    }
                  }
               })
            },
            checkgetListRegion(){
              let params={'cityCode':3065};
              params={
                data:params
              }
              // console.log(params);
              // return;
              api.common.getListRegion(params).then((res)=>{
                console.log(res);
              })
            },
            Warn (type, item) {
                const params = {
                    place: this.userInfo.depts[0].txId,
                    placeName: this.userInfo.depts[0].areaName,
                    type
                };
                if (type == 'timeLimit') {
                    params.timeLimitType = item.type;
                } else {
                    params.emergencyType = item.type;
                }
                this.$router.push({
                    path: '/complaint/warningList',
                    query: params
                })
                util.setJsonLocal('buttonType','queryList');
                
            },
            Workbench (item,checkType) { // 本级处理工作台
                util.setJsonLocal('complaintType',item.value);
                const params = {
                    placeName: this.userInfo.depts[0].areaName,
                    type: item.value,
                    place: this.userInfo.depts[0].txId
                };
                const value=item.value;
                switch(value){
                  case 'notAcceptComplainList'://待响应，指挥中心
                       util.setJsonLocal('buttonType','centerAccepted');
                       util.setJsonLocal('waitResponse','centerAccepted');
                       break;
                  case 'notHandleComplainList'://待处理，指挥中心
                       if(this.userInfo.userInfo.orgType.indexOf('tszhzx')>-1){//指挥中心
                         util.setJsonLocal('buttonType','centerHandle');
                         util.setJsonLocal('waitResponse','centerHandle');
                       }else if(this.userInfo.userInfo.orgType.indexOf('wbtj')>-1||this.userInfo.userInfo.orgType.indexOf('company')>-1){//部门
                         util.setJsonLocal('buttonType','depCompanyHandle');
                         util.setJsonLocal('waitResponse','depCompanyHandle');
                       }
                       break;
                  case 'awaitReportlist'://上报待审核，指挥中心
                       util.setJsonLocal('buttonType','reportIng');
                       util.setJsonLocal('waitResponse','reportIng');
                       break;
                  case 'superviseToAcceptList'://督办待受理，指挥中心
                       util.setJsonLocal('buttonType','superviseHandle'); 
                       util.setJsonLocal('waitResponse','superviseHandle');
                       break;
                  case 'applySplitOrderList'://拆单待审核，指挥中心
                       util.setJsonLocal('buttonType','splitOrderReportIng');
                       util.setJsonLocal('waitResponse','splitOrderReportIng');
                       break;
                  case 'applyVerifyList'://部门申诉待审核
                        util.setJsonLocal('buttonType','appealReportIng');
                        util.setJsonLocal('waitResponse','appealReportIng');
                       break;
                  case 'waitAcceptCase'://诉转案，待立案
                       util.setJsonLocal('buttonType','caseHandle');
                       break;
                  case 'awaitPendingList'://部门待处理
                       util.setJsonLocal('buttonType','depCompanyHandle');
                       util.setJsonLocal('waitResponse','depCompanyHandle');
                       break;     
                  case 'waitDealCase'://诉转案，待处理
                       util.setJsonLocal('buttonType','complainToCase');
                       break;
                  case 'feedBackList'://部门申诉待审核
                       util.setJsonLocal('buttonType','appealReportIng');
                       util.setJsonLocal('waitResponse','appealReportIng');
                       break;     
                                                       
                }
                if(checkType==3){
                  util.setJsonLocal('buttonType','queryList');
                }
                if (item.value === 'returnVisitList') {
                    params.areaOne = params.place;
                    params.fullAdress = params.placeName;
                    
                    this.$router.push({
                        path: '/complaint/returnList',
                        query: params
                    })
                    return;
                }
                this.$router.push({
                    path: '/complaint/workerListForth',
                    query: {
                        ...params
                    }
                })
            },
            goSyntheticalWarning (item) { // 轮播图跳转的页面
                const params = {place: this.userInfo.depts[0].txId ,warningType:item};
                this.$router.push({
                    path: '/complaint/comprehensiveWarningList',
                    query: {
                        ...params
                    }
                });
            },
            // 拉取待办数量
            getNoticeNum () {
                this.$store.dispatch('notice/getComplainNum');
                
            },
            statistics(){
              let obj = {
                  fullAddress:this.userInfo.depts[0].areaName,
                  areaOne:this.userInfo.depts[0].txId,
                  value: this.userInfo.depts[0].areaCode
              }
              this.$router.push({
                  path: '/complaint/visual',
                  query: {
                      fullAddress:this.userInfo.depts[0].areaName,
                      areaOne:this.userInfo.depts[0].txId,
                      value: this.userInfo.depts[0].areaCode
                  }
              })
            }
        }
    }
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  overflow: hidden;
  background-color: #fafafa;
  .container {
    width: 100%;
    .title {
      width: 100%;
      height: 83px;
      background-color: @base-color;
      position: relative;
      overflow: hidden;
      .title_text {
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: #ccc;
      }
      .title_info {
        width: 100%;
        padding: 0 16px 0 16px;
        height: 83px;
        box-sizing: border-box;
        .info{
            float: left;
            height: 100%;
        }
        .img{
            float: right;
            width: 80px;
            img{
                width: 100%;
                display: block;
                z-index: 3;
            }
        }
        .tip1 {
          font-size: 12px;
          margin-top: 24px;
          color: #FFFFFF;
        }
        .name {
          margin-top: 11px;
          display: flex;
          p {
            display: inline-block;
            vertical-align: middle;
            font-size: 12px;
            color: #FFFFFF;
          }
          .name_line {
              content:'';
              background: #fff;
              margin: 2px 5px;
              width:1px;
              height: 18px;
              -webkit-transform:scaleY(0.5);
              transform:scaleY(0.5);
              -webkit-transform-origin: 0 0;
              transform-origin: 0 0;
          }
        }
        .tip2 {
          font-size: 14px;
          color: #ccc;
          margin-top: 13px;
        }
      }
    }
    .check_list {
      width: 100%;
      padding: 0 12px;
      box-sizing: border-box;
      .item {
        width: 100%;
        margin-bottom: 20px;
        .t_text {
          font-size: 20px;
          color: #333;
          margin-top: 30px;
          font-weight: bold;
        }
        .box {
          width: 100%;
          margin-top: 15px;
          box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
          font-size: 0;
          background: #ffffff;
          .father {
            box-sizing: border-box;
            padding-top: 1px;
          }
          .left {
            width: 50%;
            height: 100px;
            display: inline-block;
            text-align: center;
            .num {
              span:nth-child(1) {
                font-size: 30px;
                color: @base-color;
                display: inline-block;
                vertical-align: bottom;
                font-weight: 700;
              }
              span:nth-child(2) {
                color: #36B374;
                display: inline-block;
                vertical-align: bottom;
                margin-left: 4px;
                margin-top: 8px;
                font-size: 32px;
                font-weight: Bold;
                font-family:PingFangSC-Regular,PingFang SC;
                -webkit-font-smoothing: antialiased;
              }
            }
            .status {
                margin-top: 24px;
                font-size: 12px;
                color: #333333;
                font-weight: Regular;
            }
          }
          .complaintStatistics {
              height: 40px;
              width: 100%;
              font-size: 14px;
              font-weight: Regular;
              color: #000000;
              line-height: 40px;
              text-align: center;
          }
        }
        .price {
          display: flex;
          display: -webkit-flex;
          flex-direction: column;
          justify-content: space-between;
          .p_item {
            // text-align: center;
            margin-top: 30px;
            .money {
              font-size: 25px;
              color: #1890ff;
              font-weight: 700;
            }
            .about_statu {
              font-size: 12px;
              color: #7d7d7d;
              margin-top: 15px;
            }
          }
        }
        .total {
          font-size: 16px;
          color: #2a2a2a;
          margin-top: 50px;
        }
        .item_price {
          width: 100%;
          .get_price {
            // text-align: center;
            margin-left: 80px;
            span:nth-child(1) {
              display: inline-block;
              width: 10px;
              height: 10px;
              vertical-align: middle;
              background-color: #50aeff;
            }
            span:nth-child(2) {
              display: inline-block;
              font-size: 13px;
              color: #7d7d7d;
              vertical-align: middle;
            }
          }
          .success_price {
            margin-top: 15px;
          }
        }
        .other_price {
          margin-top: 50px;
        }
        .fail_price {
          width: 100%;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px solid #efefef;
          span {
            font-size: 14px;
            color: #4a4a4a;
          }
          span:nth-child(1) {
            float: left;
          }
          span:nth-child(2) {
            float: right;
          }
        }
        .day_info {
          font-size: 16px;
          color: #2a2a2a;
          margin-top: 50px;
        }
        //空白图表
        .linecharts {
            width: 100%;
            height: 234px;
        }
        .comprehensiveWarning {
            width: 100%;
            height: 131px;
            .van-swipe {
              height: 131px;
              .van-swipe__indicators {
                bottom: 20px;
                .van-swipe__indicator {
                  background-color: #e9e9e9 !important;
                }
              }
            }
            .van-swipe-item {
                font-size: 14px;
                text-align: center;
                .area {
                    margin-top: 24px;
                    color: #36B374;
                    font-size: 16px;
                    font-weight: Semibold;
                }
                .totalComplaints {
                    font-size: 14px;
                    font-weight: Light;
                    color: #333333;
                    margin-top: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 0 16px;
                    line-height: 18px;
                }
                .deadline {
                    font-size: 12px;
                    color: #999999;
                    font-weight: Light;
                    margin-top: 12px;
                }
            }
        }
        .timeLimit {
            font-size: 14px;
            height: 100px;
            display: flex;
            padding: 0 10px;
            .blueWarning,.yellowWarning,.redWarning {
                flex: 1;
                margin-top: 24px;
                .warningTitle {
                    font-size: 12px;
                    color: #333333;
                    font-weight: Regular;
                    text-align: center;
                }
                .warningNum {
                    font-size: 32px;
                    font-weight: Bold;
                    margin-top: 8px;
                    text-align: center;
                }
                .blue {
                    color: #118BF5;
                }
                .yellow {
                    color: #FFA509;
                }
                .red {
                    color: #F75C32;
                }
            }
        }
        .timeLimit .blueWarning:nth-child(2) .warningNum{
          color:#FFA509;
        }
        .timeLimit .blueWarning:nth-child(3) .warningNum{
          color:#F75C32;
        }
      }
      .checkItem{

      }
    }
  }
}
</style>
<style>
#mountNode {
  /* width:400px;
      height:200px; */
}
.home_price {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  font-size: 20px;
  color: #1890ff;
}
.chart-wrapper {
  text-align: center;
  position: relative;
}
.chart-wrapper1 {
  text-align: center;
}
</style>
